import React from 'react'
import './style/Testimonial.css'
import reactDOM from 'react-dom';
function Testimonial(props) {
   
return (
     <div className='container testimonials'>
          <div className="heading">
          <h5 className="head">Testimonials</h5>
        </div>
        <div className='row'>
           {/** testimonial1 */}
                <div className='col-lg-6 col-md-6 col-sm-6'>
                   
                        <div className='testimonialContainer'>
                        <span className='beta'>Beta</span>
                        <img className='testimonialImage' src="./img/21.jpg"/>
                        <div className='stars'>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                        </div>
                        
                       
                        <p className='testimonialText'>I had the pleasure to work with Anouar on many projects, He is a very talented Student.</p>
                     <h6 className='testimonialName'>Jhon Doe</h6>
                    <div className='testimonialJob'>
                        Software Engineer<br/>
                     </div>
                         
                    
                </div>
                        
                                    
                    </div>
                    
                    {/** testimonial1 */}
                <div className='col-lg-6 col-md-6 col-sm-6'>
                    
                    <div className='testimonialContainer'>
                    <img className='testimonialImage' src="./img/3.jpg"/>
                    <span className='beta'>Beta </span>
                    <div className='stars'>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                    </div>
                    
                   
                    <p className='testimonialText'>Anouar is a fast learner who enjoys programming, and loves problems solving, Always hungry to learn.</p>
                     <h6 className='testimonialName'>Isabella</h6>
                    <div className='testimonialJob'>
                        Web Designer<br/>
                     </div>
                     
                
            </div>
                    
                                
                </div>
                
        </div>
     </div>
      
  
  );
}

export default Testimonial;
